module.exports = __webpack_public_path__ + "media/assets/site_images/soybean-7db8ca0c6cc3bc26e904751e78a7ba2b.jpg";